import React from 'react';

const Ebook = () => {
return (
<>
<div className='inter-font inmenu ebook'>
  <section className="feature-b2b-sec">
    <i className="shape-3" />
    <div className="container position-relative">
      <div className="row justify-content-center">
        <div className="col-xl-11">
          <div className="row text-white">
            <div className="col-md-6">
              <h1>The Future of B2B Marketing:</h1>
              <p>
                A Strategic Approach to the Borderless Enterprise and the Age of
                AI
              </p>
              <a href="#b2bform" className="gte-bk">
                Get the eBook
              </a>
            </div>
            <div className="col-md-6 text-end pt-4">
              <img src="assets/img/the-feature-top.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="feat-b2b-set">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="px-lg-4">
            <div className="feat-b2b-sets">
              <p>
                Business-to-Business (B2B) marketing has drastically
                transformed, from its roots in face-to-face transactions and
                print advertisements to its current state of being a dynamic,
                digitally-driven field.&nbsp;
              </p>
              <p>
                As companies have grown and expanded their operations,
                geographical boundaries that once dictated the scope and reach
                of businesses have begun to blur. This phenomenon has given
                birth to the concept of the borderless enterprise — a business
                model that operates seamlessly on a global scale, unhindered by
                traditional territorial limitations.
              </p>
              <h5 className="c-710091 pt-4">
                B2B Marketing in a Borderless Enterprise
              </h5>
              <p>
                Our latest ebook takes a deep dive at the unique challenges —
                and unparalleled opportunities — of B2B marketing in a
                borderless enterprise.
              </p>
              <h5 className="text-black amngs">
                Among the key insights discussed are:
              </h5>
              <ul className="list-df-icon">
                <li>Content strategy in a borderless enterprise (page 4)</li>
                <li>
                  Top 4 influencing decisions before accepting a B2B sales
                  meeting (page 6)
                </li>
                <li>
                  How A.I. is automating and aiding marketing decisions (page 8)
                </li>
                <li>
                  Reshaping go-to-market strategies in product companies (page
                  11)
                </li>
                <li>
                  The role of service firms in the SaaS, cloud and automation
                  world (page 13)
                </li>
                <li>
                  How should B2B marketers evolve in this new normal? (page 14)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="b2f-bform">
    <div className="container container--2">
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="px-lg-4">
            <div className="b2f-bform-in">
              <div className="row">
                <div className="col-md-6">
                  <h2>Get the eBook</h2>
                  <p>
                    The new normal in B2B marketing is complex but filled with
                    opportunities.
                  </p>
                  <p>
                    Get our ebook to learn how B2B marketers can create more
                    meaningful connections and drive business growth by aligning
                    strategies with the shifts in technology, global reach, and
                    customer behavior.
                  </p>
                </div>
                <div className="col-md-6" id="b2bform">
                  <img src="assets/img/the-feature-1.png" alt="the-feature-1" />
                </div>
              </div>
              <div className="feat-b2b-froms"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</>



  );
};

export default Ebook;